import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Components
import Input from "../../components/FormElements/Input";

//
import { signupSchema } from "../../utils/schemas/userSchema";
import UserMiddlewares from "../../store/middlewares/UserMiddlewares";

const SignupForm = () => {
  const dispatch = useDispatch();
  const { isError, errorMessage, isLoading } = useSelector(
    (state) => state.user.signup
  );
  const { t } = useTranslation();

  const form = useForm({
    resolver: yupResolver(signupSchema),
  });
  const {
    handleSubmit,
    formState: { errors },
  } = form;

  const signupHandler = (data) => {
    dispatch(UserMiddlewares.signup(data));
  };

  return (
    <FormProvider {...form}>
      <div className="form-wrapper my-5">
        <h3 className="mb-3">{t("signup.formTitle")}</h3>

        <form onSubmit={handleSubmit(signupHandler)}>
          {isError && <div className="error-message">{errorMessage}</div>}
          <div className="mb-2">
            <Input
              id="firstname"
              name="firstname"
              placeholder={t("signup.firstnamePlaceholder")}
              label={t("signup.firstnameLabel")}
              error={errors?.firstname?.message}
            />
          </div>
          <div className="mb-2">
            <Input
              id="lastname"
              name="lastname"
              placeholder={t("signup.lastnamePlaceholder")}
              label={t("signup.lastnameLabel")}
              error={errors?.lastname?.message}
            />
          </div>
          <div className="mb-2">
            <Input
              id="email"
              name="email"
              placeholder={t("signup.emailPlaceholder")}
              label={t("signup.emailLabel")}
              error={errors?.email?.message}
            />
          </div>
          <div className="mb-2">
            <Input
              id="password"
              name="password"
              placeholder={t("signup.passwordPlaceholder")}
              label={t("signup.passwordLabel")}
              error={errors?.password?.message}
              type="password"
            />
          </div>
          <div className="d-grid gap-2 my-3">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isLoading}
            >
              {isLoading
                ? t("signup.signupButtonLoading")
                : t("signup.signupButton")}
            </button>
          </div>
          <p className="text-center mb-0">
            {t("signup.memberText")}{" "}
            <Link to="/login">{t("signup.loginLink")}</Link>.
          </p>
        </form>
      </div>
    </FormProvider>
  );
};

export default SignupForm;
